import * as firebase from "firebase";
/* Module1.store.js */

// State object

const state = {
  user: null, //user-id from the firebase once a user is signed or signup
  status: null //login or signup success or not.
};

// Getter functions
const getters = {
  user(state) {
    return state.user;
  },

  status(state) {
    return state.status;
  },

};

// Actions
const actions = {

  signUpUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {

        // eslint-disable-next-line no-console
        console.log(payload);

        // eslint-disable-next-line no-console
        console.log("Creando ");

        // eslint-disable-next-line no-console
        console.log(payload);


        // Add a new document with a generated id.
        firebase.firestore()
          .collection("User")
          .doc(payload.id)
          .set({
            first_name: payload.name,
            last_name: payload.last_name,
            email: { "primary": payload.email }
          })
          .then(() => {
            firebase.auth().currentUser.updateProfile({
              displayName: payload.name + " " + payload.last_name
            })
              .then(() => {
                commit('setStatus', 'success')
                resolve();
              });
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err);
            reject();
          });
      }, 5000);
    });
  },

  signUpUserOrcid({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit("setStatus", "loading");

        // eslint-disable-next-line no-console
        console.log("Creando ");
        // eslint-disable-next-line no-console
        console.log(payload.id);

        var data = {
          orcid_id: payload.orcid_id,
          email: { "primary": payload.email }
        };
        if (payload.first_name) {
          data["first_name"] = payload.first_name;
        }
        if (payload.last_name) {
          data["last_name"] = payload.last_name;
        }
        if (payload.about_me) {
          data["about_me"] = payload.about_me;
        }
        if (payload.country) {
          data["country"] = payload.country;
        }
        if (payload.experience) {
          data["experience"] = payload.experience;
        }
        if (payload.education) {
          data["education"] = payload.education;
        }
        if (payload.projects) {
          data["projects"] = payload.projects;
        }

        // Add a new document with a generated id.
        firebase
          .firestore()
          .collection("User")
          .doc(payload.id)
          .set(data)
          .then(() => {
            // eslint-disable-next-line no-console
            console.log("Usuario creado")
            firebase.auth().currentUser.updateProfile({
              displayName: payload.first_name + " " + payload.last_name
            })
              .then(() => {
                commit("setStatus", "success");
                commit("setUser", payload.id);
                resolve();
              });
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log(error);
            reject();
          })
      });
    }, 5000);
  },

  login({ commit }, payload) {
    commit("setStatus", "loading");


    // eslint-disable-next-line no-console
    console.log(payload);

    firebase
      .firestore()
      .collection("User")
      .doc(payload.user.email)
      .get()
      .then(doc => {
        if (!doc.exists) {
          //eslint-disable-next-line no-console


          // eslint-disable-next-line no-console
          console.log(payload);

          firebase
            .firestore()
            .collection("User")
            .doc(payload.user.email)
            .get()
            .then(doc => {
              if (!doc.exists) {
                //eslint-disable-next-line no-console

              } else {
                //eslint-disable-next-line no-console
                console.log("Document data:", doc.data());
                if (payload) {
                  commit("setStatus", payload !== null);
                  commit("setUser", payload.user.uid);
                } else {
                  commit("removeUser", null);
                }
              }
            });
          commit("setStatus", "success login");
        }
      });
  },

  loginGoogle({ commit }, payload) {

    commit('setStatus', 'loading');

    // eslint-disable-next-line no-console
    console.log("Ingreso a la función")

    // eslint-disable-next-line no-console
    console.log("Payload: " + JSON.stringify(payload));

    firebase.firestore()
      .collection("User")
      .doc(payload.uid)
      .get()
      .then(doc => {


        if (!doc.exists) {
          //eslint-disable-next-line no-console
          console.log("No existe el usuario en la base de User");



              // eslint-disable-next-line no-console
    console.log("Payload uid " + payload.uid);

          //crea el nuevo documento
          firebase
            .firestore()
            .collection("User")
            .doc(payload.uid)
            .set({ email: { "primary": payload.email, "orcid": "" } })
            .then(function () {
              //eslint-disable-next-line no-console
              console.log("Usuario creado!");}).catch(function (error) {
              // An error happened.
              // eslint-disable-next-line no-console
              console.log("El usuario no fue creado" + error);
            });} else {
          //eslint-disable-next-line no-console
          console.log("Document data:", doc.data());

          if (payload) {
            
            firebase.firestore()
              .collection("User")
              .doc(payload.uid)
              .set({ email: { "primary": payload.email, "orcid": "" } }, { merge: true })
              .then(() => {

                firebase.auth().currentUser.updateProfile({
                  uid: payload.uid
                }).then(function () {
                  // Update successful.
                  // eslint-disable-next-line no-console
                  console.log("Usuario actualizado.");

                }).catch(function (error) {
                  // An error happened.
                  // eslint-disable-next-line no-console
                  console.log(error);
                  // eslint-disable-next-line no-console
                  console.log("El usuario no fue actualizado");
                });

              })
              .catch(() => {
                // eslint-disable-next-line no-console
                console.log("El usuario no fue actualizado");
              });
            commit("setStatus", payload !== null);
            commit("setUser", payload.uid);

          } else {
            commit("removeUser", null);
          }
        }
      }).catch(() => {
        // eslint-disable-next-line no-console
        console.log("El usuario no fue actualizado");
      });

    commit('setStatus', 'success login');


  },

  loginOrcid({ commit }, payload) {
    firebase.auth().currentUser.updateProfile({
      displayName: payload.first_name + " " + payload.last_name
    })
      .then(() => {
        commit("setStatus", payload !== null);
        commit("setUser", payload.id);
        commit('setStatus', 'success login');
      });
  },

  logout({ commit, dispatch }) {

    firebase
      .auth()
      .signOut()
      .then(() => {
        // eslint-disable-next-line no-console
        console.log("Redirección a página de inicio");


        // eslint-disable-next-line no-console
        // console.log(JSON.stringify(paulcurrentUseroad));


        // commit('removeUser', s)
        commit('removeUser')
        commit('setStatus',null)

        //localStorage.clear();


        //window.localStorage.clear();




        // eslint-disable-next-line no-console
        console.log("Borrar persistencia");
        dispatch("tagsView/delAllViews", null, { root: true }); });
        // firebase.auth.GoogleAuthProvider()

        //borrar el tocken :V

        // FirebaseAuth.getInstance().signOut();

        // GoogleSignInClient.signOut();
        // GoogleSignInOptions gso = new GoogleSignInOptions.Builder(GoogleSignInOptions.DEFAULT_SIGN_IN)
        //                         .requestIdToken(getString(R.string.default_web_client_id))
        //                         .requestEmail()
        //                         .build();
        //                 mGoogleSignInClient = GoogleSignIn.getClient(SettingsActivity.this, gso);

        firebase.firestore().clearPersistence();

    // eslint-disable-next-line no-console
    console.log("Borrar persistencia");
  },

  readProfile({ commit }) {

    const userId = firebase.auth().currentUser.uid;
    // eslint-disable-next-line no-console
    console.log(userId)

    firebase.firestore()
      .collection('User')
      .doc(userId).get()
      .then(res => {
        // eslint-disable-next-line no-console
        console.log(res.data())

        commit("setUser", res.data());
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log(err);
      });

  },


  changeState({ commit }, { field, data }) {
    // eslint-disable-next-line no-console
    commit("updateProfile", { field, data });
  },


  modifyUser({ commit }, payload) {

    commit('setStatus', 'loading');

    const userId = firebase.auth().currentUser.uid;
    // eslint-disable-next-line no-console
    console.log("Ingresando a modificación." + JSON.stringify(payload));

    var userInfo = {
    };

    if (payload.first_name) {
      userInfo["first_name"] = payload.first_name;
    }
    if (payload.last_name) {
      userInfo["last_name"] = payload.last_name;
    }
    if (payload.company) {
      userInfo["company"] = payload.company;
    }
    if (payload.role) {
      userInfo["role"] = payload.role;
    }
    if (payload.about_me) {
      userInfo["about_me"] = payload.about_me;
    }
    if (payload.address) {
      userInfo["address"] = payload.address;
    }
    if (payload.email) {
      userInfo["email"] = payload.email;
    }
    if (payload.city) {
      userInfo["city"] = payload.city;
    }
    if (payload.country) {
      userInfo["country"] = payload.country;
    }

    firebase.firestore()
      .collection('User')
      .doc(userId)
      .update(userInfo)
      .then(() => {
        // eslint-disable-next-line no-console
        console.log("Usuario actualizado.");
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.log("El usuario no fue actualizado");
      });
  },

  /*readProfile({ commit }) {
    const userId = firebase.auth().currentUser.uid;
    // eslint-disable-next-line no-console
    console.log(userId);

    firebase
      .firestore()
      .collection("User")
      .doc(userId)
      .get()
      .then(res => {
        // eslint-disable-next-line no-console
        console.log(res.data());

        commit("setUser", res.data());
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  },

  changeState({ commit }, { field, data }) {
    // eslint-disable-next-line no-console
    commit("updateProfile", { field, data });
  },*/


  updateUser({ commit }, { payload }) {

    // eslint-disable-next-line no-console
    console.log("Ingresando a modificación. " + payload);

    commit('setStatus', 'loading');
    commit('user', payload);
    commit('setUser', payload);

  }

};

// Mutations
const mutations = {
  // mutation to update currently authenticated user.

  //it will set the user we got from the firebase
  setUser(state, payload) {
    state.user = payload;
  },

  //it will remove the user-id from the state.
  removeUser(state) {
    state.user = null;
  },

  //it will change the status
  setStatus(state, value) {
    state.status = value;
  },

  updateProfile(state, { field, data }) {
    if (Array.isArray(state.user[field])) {
      state.user[field] = [];
      state.user[field].push(data);
    } else if (field.includes(".")) {
      const fields = field.split(".");
      state.user[fields[0]][fields[1]] = data;
    } else {
      state.user[field] = data;
    }
  }


};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

